import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { officesListBreadcrumbsHistory } from './functions';

const OfficesListBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="offices-list-breadcrumbs"
      history={officesListBreadcrumbsHistory(t, location)}
    />
  );
};

export default OfficesListBreadcrumbs;
